import '../../components.theme/page-shops-index/page-shops-index';
import './page-shops-index.scss';
